.card {
  display: block;
  border: 1px solid #eee;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background: white;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.imageWrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f6f4f0;
}

.image {
  object-fit: cover;
}

.imagePlaceholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f2f2f2, #e9e9e9);
}

.collectionBadge {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px 10px;
  background: #505050;
  color: white;
  font-size: 11px;
  font-weight: 500;
  border-radius: 999px;
  letter-spacing: 0.02em;
}

/* ── Color swatches ── */

.swatchesRow {
  display: flex;
  gap: 6px;
  padding: 10px 14px 0;
}

.swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  outline: none;
  transition:
    border-color 0.15s ease,
    transform 0.1s ease;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.swatch:hover {
  transform: scale(1.15);
}

.swatchTexture {
  background-size: cover;
  background-position: center;
}

.swatchActive {
  border-color: #505050;
}

/* ── Card body ── */

.cardBody {
  padding: 8px 14px 16px;
}

.title {
  font-weight: 400;
  font-size: 15px;
  line-height: 1.3;
  color: #333;
}

.dimensions {
  margin-top: 4px;
  font-size: 13px;
  color: #888;
}

.price {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

/* Placeholder shown while the live quote loads (price is never hard-coded). */
.priceSkeleton {
  display: inline-block;
  width: 90px;
  height: 15px;
  border-radius: 4px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 37%, #ececec 63%);
  background-size: 400% 100%;
  animation: priceShimmer 1.4s ease infinite;
}

@keyframes priceShimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

@media (max-width: 600px) {
  .card {
    border-radius: 14px;
  }

  .swatchesRow {
    padding: 8px 10px 0;
    gap: 5px;
  }

  .swatch {
    width: 20px;
    height: 20px;
  }

  .cardBody {
    padding: 6px 10px 12px;
  }

  .title {
    font-size: 13px;
  }

  .price {
    font-size: 13px;
  }

  .dimensions {
    font-size: 11px;
  }
}
